var map = {
	"./configurator/back-side.svg": "8bf1",
	"./configurator/background.svg": "4558",
	"./configurator/custom-side.svg": "e557",
	"./configurator/engraving.svg": "17e9",
	"./configurator/front-side.svg": "57d2",
	"./configurator/ic-add-view.svg": "b32f",
	"./configurator/ic-arrow-left.svg": "829b",
	"./configurator/ic-arrow-right.svg": "93c9",
	"./configurator/ic-background.svg": "ee9b",
	"./configurator/ic-engraving.svg": "7306",
	"./configurator/ic-exit.svg": "c317",
	"./configurator/ic-logo.svg": "9817",
	"./configurator/ic-shadow-controls.svg": "b96f",
	"./configurator/ic-view.svg": "51e5",
	"./configurator/logo.svg": "db11",
	"./configurator/perspective.svg": "77fd",
	"./configurator/side.svg": "2951",
	"./configurator/view.svg": "b7fb",
	"./configurator/watermark.svg": "35a5",
	"./ic-arrow-bold-left.svg": "f8fa",
	"./ic-arrow-down.svg": "b904",
	"./ic-arrow-right-white.svg": "5c2c",
	"./ic-arrow-right.svg": "075d",
	"./ic-arrow-tin-down.svg": "5180",
	"./ic-bell-notification.svg": "b37d",
	"./ic-box.svg": "ce88",
	"./ic-calendar.svg": "47d8",
	"./ic-canvas-comment-hover.svg": "ad6a",
	"./ic-caret-down.svg": "1f69",
	"./ic-caret-up.svg": "b631",
	"./ic-check.svg": "57f8",
	"./ic-checked.svg": "96ba",
	"./ic-chevron-down-circle-outline.svg": "50da",
	"./ic-close-modal.svg": "c280",
	"./ic-close.svg": "d41d",
	"./ic-comment-blue.svg": "0742",
	"./ic-comment-orange.svg": "240c",
	"./ic-comment.svg": "b976",
	"./ic-copy-solid.svg": "7f29",
	"./ic-copy.svg": "89bf",
	"./ic-download.svg": "c77d",
	"./ic-draw-down.svg": "c2b7",
	"./ic-draw-edit.svg": "0e53",
	"./ic-draw-grater.svg": "a102",
	"./ic-draw-slider.svg": "69a8",
	"./ic-draw-zoom.svg": "a0ae",
	"./ic-edit-title.svg": "971f",
	"./ic-edit.svg": "25ae",
	"./ic-exit.svg": "910f",
	"./ic-expand-panel.svg": "f9a5",
	"./ic-expand.svg": "f696",
	"./ic-ext-link.svg": "1a71",
	"./ic-google-mini-logo.svg": "c057",
	"./ic-info-red.svg": "36e5",
	"./ic-info.svg": "94f8",
	"./ic-lock.svg": "e59d",
	"./ic-messenger.svg": "0430",
	"./ic-player-play.svg": "d34f",
	"./ic-plus-circle.svg": "5262",
	"./ic-plus-white.svg": "f978",
	"./ic-plus.svg": "4258",
	"./ic-pt-band.svg": "8120",
	"./ic-pt-bracelet.svg": "7eeb",
	"./ic-pt-cuffs.svg": "86c8",
	"./ic-pt-earrings.svg": "f786",
	"./ic-pt-mix.svg": "2851",
	"./ic-pt-necklace.svg": "6a78",
	"./ic-pt-plus.svg": "ad64",
	"./ic-pt-ring.svg": "b66e",
	"./ic-remove.svg": "d175",
	"./ic-rename.svg": "953b",
	"./ic-slider-left-control.svg": "293d",
	"./ic-slider-right-control.svg": "d26f",
	"./ic-trash.svg": "ce1a",
	"./ic-upload-dark.svg": "a51c",
	"./ic-upload-lable.svg": "1daf",
	"./ic-upload.svg": "1ae9",
	"./ic-user-profile.svg": "3583",
	"./ic_clock.svg": "7353",
	"./ic_message.svg": "85d5",
	"./ic_payed.svg": "f685",
	"./ic_warning.svg": "45b4",
	"./icon.svg": "a11f",
	"./payment/ic-payment-add.svg": "9793",
	"./payment/ic-payment-ct-master.svg": "8cba",
	"./payment/ic-payment-ct-mastercard.svg": "2507",
	"./payment/ic-payment-ct-visa.svg": "876e",
	"./payment/ic-payment-r-amazon-active.svg": "1a29",
	"./payment/ic-payment-r-amazon.svg": "c654",
	"./payment/ic-payment-r-card-active.svg": "4d29",
	"./payment/ic-payment-r-card.svg": "0a5b",
	"./payment/ic-payment-r-paypal-active.svg": "3dbf",
	"./payment/ic-payment-r-paypal.svg": "a51a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";